export default __webpack_public_path__ + "static/media/instagram-gold.95eecf15.svg";